if (typeof performance !== "undefined" && typeof performance.mark === "function") {
    performance.mark("checkout_bootstrap_start");
}

if (typeof window !== "undefined" && typeof window.requestIdleCallback !== "function") {
    require("requestidlecallback");
}

import { Sdk } from "./NativeBridgeSdk";
import { mockWebSdk } from "@swiggy-private/native-bridge";

if (__DEV__) {
    if (document.documentElement.classList.contains("web")) {
        mockWebSdk();
    }
}

Sdk?.showHeader({ show: false, title: "" }).catch((err) => __DEV__ && console.error(err));

if (typeof performance !== "undefined" && typeof performance.mark === "function") {
    performance.mark("checkout_bootstrap_end");
}
